import { render, staticRenderFns } from "./new-activity.vue?vue&type=template&id=6b9f1b96&scoped=true&"
import script from "./new-activity.vue?vue&type=script&lang=ts&"
export * from "./new-activity.vue?vue&type=script&lang=ts&"
import style0 from "./new-activity.vue?vue&type=style&index=0&id=6b9f1b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f1b96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
